document.addEventListener('DOMContentLoaded', function() {

  // ── CART DRAWER ────────────────────────────────────────────
  var cartBtn    = document.getElementById('cart-toggle-btn');
  var cartDrawer = document.getElementById('cart-drawer');
  var cartClose  = document.getElementById('cart-close-btn');
  var overlay    = document.getElementById('fours-overlay');

  function openCart() {
    if(cartDrawer) cartDrawer.classList.add('open');
    if(overlay) overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    fetchCart();
  }
  function closeAll() {
    if(cartDrawer) cartDrawer.classList.remove('open');
    var mob = document.getElementById('mob-drawer');
    if(mob) mob.classList.remove('open');
    if(overlay) overlay.classList.remove('active');
    document.body.style.overflow = '';
  }
  if(cartBtn) cartBtn.addEventListener('click', openCart);
  if(cartClose) cartClose.addEventListener('click', closeAll);
  if(overlay) overlay.addEventListener('click', closeAll);
  document.addEventListener('keydown', function(e) {
    if(e.key === 'Escape') closeAll();
  });

  // ── MOBILE DRAWER ──────────────────────────────────────────
  var hamburger = document.getElementById('hamburger-btn');
  var mobClose  = document.getElementById('mob-close-btn');
  var mobDrawer = document.getElementById('mob-drawer');

  if(hamburger) hamburger.addEventListener('click', function() {
    if(mobDrawer) mobDrawer.classList.add('open');
    if(overlay) overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  });
  if(mobClose) mobClose.addEventListener('click', closeAll);

  // ── CART FETCH ─────────────────────────────────────────────
  function fetchCart() {
    fetch('/cart.js')
      .then(function(r){ return r.json(); })
      .then(function(cart){ updateCartUI(cart); });
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function updateCartUI(cart) {
    document.querySelectorAll('#cart-count, .cart-count').forEach(function(el){
      el.textContent = cart.item_count;
    });
    var itemsEl = document.getElementById('cart-items-list');
    if(!itemsEl) return;
    if(cart.item_count === 0) {
      itemsEl.innerHTML = '<div class="cart-empty">Your cart is empty</div>';
    } else {
      itemsEl.innerHTML = cart.items.map(function(item) {
        var key   = escapeHtml(item.key);
        var name  = escapeHtml(item.product_title);
        var brand = escapeHtml(item.vendor);
        var img   = item.image
          ? '<img class="cart-item-img" src="' + escapeHtml(item.image) + '" alt="' + name + '"/>'
          : '<div class="cart-item-img"></div>';
        return '<div class="cart-item" data-key="' + key + '">' +
          img +
          '<div class="cart-item-info">' +
            '<div class="cart-item-brand">' + brand + '</div>' +
            '<div class="cart-item-name">' + name + '</div>' +
            '<div class="cart-item-price">' + formatMoney(item.final_price) + '</div>' +
            '<div class="cart-qty">' +
              '<button type="button" class="cart-qty-btn" data-key="' + key + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease quantity">&minus;</button>' +
              '<span class="cart-qty-val">' + item.quantity + '</span>' +
              '<button type="button" class="cart-qty-btn" data-key="' + key + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase quantity">+</button>' +
            '</div>' +
          '</div>' +
          '<button class="cart-item-remove" data-key="' + key + '" data-qty="0" aria-label="Remove item">&#10005;</button>' +
        '</div>';
      }).join('');
    }
    var sub = document.getElementById('cart-subtotal-price');
    if(sub) sub.textContent = formatMoney(cart.total_price);
  }

  // Shopify-compatible money formatter driven by the shop's money_format.
  function formatMoney(cents) {
    var fmt = window.FOURS_MONEY_FORMAT || '\u00a3{{amount}}';
    function num(precision, thousands, decimal) {
      var value = (isNaN(cents) || cents == null) ? 0 : cents;
      value = (value / 100).toFixed(precision);
      var parts = value.split('.');
      var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var frac = parts[1] ? (decimal + parts[1]) : '';
      return whole + frac;
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/g, function(match, token) {
      switch (token) {
        case 'amount':                                  return num(2, ',', '.');
        case 'amount_no_decimals':                      return num(0, ',', '.');
        case 'amount_with_comma_separator':             return num(2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return num(0, '.', ',');
        case 'amount_with_apostrophe_separator':        return num(2, "'", '.');
        default:                                        return '';
      }
    });
  }

  // Set a cart line to a specific quantity (0 removes it).
  function foursChangeQty(key, qty) {
    if(isNaN(qty) || qty < 0) qty = 0;
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    }).then(function(r){ return r.json(); }).then(updateCartUI);
  }
  window.foursChangeQty = foursChangeQty;
  // Backwards-compatible alias.
  window.removeCartItem = function(key) { foursChangeQty(key, 0); };

  // Delegated handler: works for both server-rendered and JS-rendered items.
  var itemsListEl = document.getElementById('cart-items-list');
  if(itemsListEl) {
    itemsListEl.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-key][data-qty]');
      if(!btn) return;
      foursChangeQty(btn.getAttribute('data-key'), parseInt(btn.getAttribute('data-qty'), 10));
    });
  }

  // Product-page quantity stepper.
  document.addEventListener('click', function(e) {
    var qb = e.target.closest('.qty-btn');
    if(!qb) return;
    var wrap = qb.closest('.qty-selector');
    if(!wrap) return;
    var input = wrap.querySelector('.qty-input');
    if(!input) return;
    var step = parseInt(qb.getAttribute('data-step'), 10) || 0;
    var val = (parseInt(input.value, 10) || 1) + step;
    if(val < 1) val = 1;
    input.value = val;
  });

  // ── AJAX ADD TO CART ───────────────────────────────────────
  // Delegated so it reliably catches every /cart/add form and never
  // falls back to a full-page POST.
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if(!(form instanceof HTMLFormElement)) return;
    var action = form.getAttribute('action') || '';
    if(action.indexOf('/cart/add') === -1) return;
    e.preventDefault();
    var data = new FormData(form);
    if(!data.get('id')) return;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: data.get('id'),
        quantity: parseInt(data.get('quantity'), 10) || 1
      })
    })
    .then(function(r){ return r.json(); })
    .then(function(res){
      if(res && res.status) { throw res; }
      fetchCart();
      openCart();
    })
    .catch(function(err){
      console.error('Cart error:', err);
      if(window.showToast) showToast('Sorry, that could not be added to your cart.');
    });
  });

  // ── SHOWCASE DRAG ──────────────────────────────────────────
  var showcaseWrap  = document.getElementById('showcase-track-wrap');
  var showcaseTrack = document.getElementById('showcase-track');
  var dotsWrap      = document.getElementById('showcase-dots');

  if(showcaseWrap && showcaseTrack) {
    var isDragging = false, startX = 0, startScroll = 0, hasMoved = false;

    if(dotsWrap) {
      var cards = showcaseTrack.querySelectorAll('.showcase-card');
      dotsWrap.innerHTML = '';
      cards.forEach(function(_, idx) {
        var dot = document.createElement('div');
        dot.className = 'showcase-dot' + (idx === 0 ? ' active' : '');
        dot.addEventListener('click', function() {
          showcaseWrap.scrollTo({ left: idx * (cards[0].offsetWidth + 16), behavior: 'smooth' });
        });
        dotsWrap.appendChild(dot);
      });
    }

    function updateDots() {
      var cards2 = showcaseTrack.querySelectorAll('.showcase-card');
      if(!cards2.length || !dotsWrap) return;
      var idx = Math.round(showcaseWrap.scrollLeft / (cards2[0].offsetWidth + 16));
      dotsWrap.querySelectorAll('.showcase-dot').forEach(function(d, i){
        d.classList.toggle('active', i === idx);
      });
    }

    showcaseWrap.addEventListener('scroll', updateDots, { passive: true });

    showcaseWrap.addEventListener('mousedown', function(e) {
      if(e.button !== 0) return;
      isDragging = true; hasMoved = false;
      startX = e.clientX; startScroll = showcaseWrap.scrollLeft;
      showcaseWrap.style.cursor = 'grabbing';
      showcaseTrack.style.pointerEvents = 'none';
      e.preventDefault();
    });

    window.addEventListener('mousemove', function(e) {
      if(!isDragging) return;
      var dx = e.clientX - startX;
      if(Math.abs(dx) > 4) hasMoved = true;
      showcaseWrap.scrollLeft = startScroll - dx;
    });

    window.addEventListener('mouseup', function() {
      if(!isDragging) return;
      isDragging = false;
      showcaseWrap.style.cursor = '';
      showcaseTrack.style.pointerEvents = '';
      updateDots();
    });
  }

  // ── HEADER SCROLL ──────────────────────────────────────────
  var header = document.getElementById('fours-header');
  if(header) {
    window.addEventListener('scroll', function() {
      header.style.borderBottomColor = window.scrollY > 20
        ? 'rgba(255,255,255,0.1)' : 'rgba(255,255,255,0.06)';
    }, { passive: true });
  }

  // ── TOAST ──────────────────────────────────────────────────
  window.showToast = function(msg) {
    var t = document.getElementById('toast');
    if(!t) return;
    t.textContent = msg;
    t.classList.add('show');
    setTimeout(function(){ t.classList.remove('show'); }, 3500);
  };

});
